export function getSettings( state ) {
	return state.settings;
}
export function getSiteOptions( state ) {
	return state.site_options;
}

export function getTemplateData( state, id ) {
	return state.templatesData[ id ];
}
